import { render, staticRenderFns } from "./alert_assesment_teach.vue?vue&type=template&id=f30f8c3c&scoped=true&"
import script from "./alert_assesment_teach.vue?vue&type=script&lang=js&"
export * from "./alert_assesment_teach.vue?vue&type=script&lang=js&"
import style0 from "./alert_assesment_teach.vue?vue&type=style&index=0&id=f30f8c3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30f8c3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCard,VCardText,VCardTitle,VIcon,VSpacer})
